import styled, { keyframes } from 'styled-components';
import { TextBlock } from '../text';
import { FontSize18, FontFamilyMedium } from '../fonts';

export const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0,0.1);
`;

const slideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(200px);
    }

    30% {
        opacity: 1;
    }

    to {
        opacity: 1;
        transform: translateY(0px);
    }
`;

const slideDown = keyframes`
    from {
        opacity: 1;
        transform: translateY(0);
    }

    30% {
        opacity: 1;
    }

    to {
        opacity: 0;
        transform: translateY(200px);     
    }
`;

export const ModalContainer = styled.div`
    width: 100%;
    position: relative;
    max-width: ${props => props.large ? '600px' : '480px'};
    background-color: white;
    animation: ${props => props.isClosing ? slideDown : slideUp} 0.2s linear;
    animation-fill-mode: forwards;
    z-index: 101;
    padding: ${props => props.hasBottomButton ? '0 0 50px 0' : '0'};
    border-radius: 20px;
    max-height: ${props => props.isExtraLarge ? '100%' : '90%'};
    display: flex;
    flex-direction: column;

    ${props => props.isExtraLarge && 'height: 100%'};
    ${props => props.isExtraLarge && 'max-width: 100%'};
    ${props => props.isExtraLarge && 'border-radius: 20px 20px 0 0'};

    ${props => props.theme.mediaQueries.desktop} {
        height: auto;
        max-height: 90%;
        ${props => props.isExtraLarge && 'max-width: 1055px'};
        border-radius: 20px;
    }
`;

export const ModalHeader = styled.div`
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ModalHeaderTitle = styled(TextBlock)`
    ${FontSize18};
    ${FontFamilyMedium};
    margin-right: 50px;
    padding-left: 8px;
`;

const layerAppear = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 0.8;
    }
`;

const layerDisappear = keyframes`
    from {
        opacity: 0.8;
    }

    to {
        opacity: 0;
    }
`;

export const Layer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    animation: ${props => props.isClosing ? layerDisappear : layerAppear} 0.2s linear;
    background-color: rgb(0, 0, 0);
    animation-fill-mode: forwards;
`;

export const ButtonContainer = styled.div`
    width: 50%; 
    position: absolute;
    bottom: -21px;
    left: 50%;
    transform: translateX(-50%);
`;

export const CloseIconWrapper = styled.div`
    position: absolute;
    right: 20px;
    width: 21px;
    height: 21px;
    cursor: pointer;
`;